import { render, staticRenderFns } from "./ProjectBreadCrumbs.vue?vue&type=template&id=5afe5790&scoped=true&"
import script from "./ProjectBreadCrumbs.vue?vue&type=script&lang=ts&"
export * from "./ProjectBreadCrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectBreadCrumbs.vue?vue&type=style&index=0&id=5afe5790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afe5790",
  null
  
)

export default component.exports